import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SubdominioService } from '@app/services/general/subdominio.service';
import { SlugSubdominio } from '@app/enums/subdominio.enum';
import { RoutesUrl } from '@app/routes.enum';

// El portal público es de liga — los subdominios de equipo y admin no tienen portal,
// salvo las rutas marcadas con `permiteSubdominioEquipo` (no dependen de la liga del
// subdominio, ej. actualizar jugador por ?e=, o enlace-no-disponible), que sí deben
// abrir desde team.* y admin.*.
export const subdominioPortalGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const subdominioService = inject(SubdominioService);
  const router = inject(Router);

  const slug = subdominioService.slugActual();
  if ((slug === SlugSubdominio.EQUIPO || slug === SlugSubdominio.ADMIN) && route.data['permiteSubdominioEquipo']) {
    return true;
  }
  if (slug === SlugSubdominio.EQUIPO || slug === SlugSubdominio.ADMIN) {
    return router.parseUrl(`/${RoutesUrl.MAIN}`);
  }

  return true;
};
